/* ============================================================================
   Modolino – theme.js (globales Theme-JavaScript, ohne jQuery)
   Ersetzt das frühere app.js (jQuery) + den Cart-Drawer-Fix aus layout/theme.liquid.

   Zuständig für:
   1. Mobiles Menü (öffnen, schließen, Untermenüs, Logo-Kopie)
   2. Warenkorb-Drawer öffnen (Icon im Header, nach "In den Warenkorb")
   3. Footer-Spalten als Akkordeon auf dem Smartphone
   4. Theme-Editor: Drawer nach dem Speichern automatisch öffnen

   Alles andere (Warenkorb-Inhalt, Mengen, Rabattcodes, Schließen) steckt in
   assets/cart.js (Drawer und Warenkorbseite).
   ========================================================================== */
(function () {
  'use strict';

  var CART_SECTION_ID = 'global-cart-drawer'; /* Dateiname der Drawer-Section (ohne .liquid) */

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------------------
     1. Mobiles Menü
     --------------------------------------------------------------------- */
  var mobileMenu = qs('#mobile-menu');
  var mobileOverlay = qs('#mobile-menu-overlay');
  var mobileContent = qs('#mobile-menu-content');
  var mobileToggle = qs('.header-menu-mobile-menu');
  var mobileHideTimer = null; /* Ausblend-Timer, damit schnelles Wieder-Öffnen das Menü nicht versteckt */

  function isMobileMenuOpen() { return !!mobileMenu && mobileMenu.classList.contains('mm-open'); }

  function openMobileMenu() {
    if (!mobileMenu) return;
    clearTimeout(mobileHideTimer);
    mobileMenu.style.visibility = 'visible';
    if (mobileOverlay) mobileOverlay.style.opacity = '0.5';
    if (mobileContent) mobileContent.style.transform = 'translateX(0%)';
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    mobileMenu.classList.add('mm-open');                 /* blendet die Inhalte gestaffelt ein */
    document.documentElement.classList.add('mm-lock');   /* Seite dahinter scrollt nicht mit */
    var closeBtn = qs('.mobile-menu-header-close-icon', mobileMenu);
    if (closeBtn) setTimeout(function () { closeBtn.focus({ preventScroll: true }); }, 50);
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    var wasOpen = isMobileMenuOpen();
    if (mobileOverlay) mobileOverlay.style.opacity = '0';
    if (mobileContent) mobileContent.style.transform = 'translateX(-100%)';
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    mobileMenu.classList.remove('mm-open');
    document.documentElement.classList.remove('mm-lock');
    clearTimeout(mobileHideTimer);
    mobileHideTimer = setTimeout(function () { mobileMenu.style.visibility = 'hidden'; }, 420);
    if (wasOpen && mobileToggle) mobileToggle.focus({ preventScroll: true });
  }

  if (mobileToggle) mobileToggle.addEventListener('click', openMobileMenu);
  qsa('.mobile-menu-header-close-icon').forEach(function (el) { el.addEventListener('click', closeMobileMenu); });
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isMobileMenuOpen()) closeMobileMenu(); });

  /* Theme-Editor: Menü öffnen, solange die Section ausgewählt ist */
  document.addEventListener('shopify:section:select', function (e) { if (mobileContent && e.target.contains(mobileContent)) openMobileMenu(); });
  document.addEventListener('shopify:section:deselect', function (e) { if (mobileContent && e.target.contains(mobileContent)) closeMobileMenu(); });

  /* Logo aus dem Header in den Kopf des mobilen Menüs kopieren */
  var headerLogo = qs('.header-menu-logo img');
  var mobileHeader = qs('.mobile-menu-header');
  if (headerLogo && mobileHeader && !qs('img', mobileHeader)) {
    var logoCopy = headerLogo.cloneNode(true);
    logoCopy.style.height = 'auto';
    logoCopy.removeAttribute('fetchpriority');
    logoCopy.setAttribute('loading', 'lazy');
    mobileHeader.insertBefore(logoCopy, mobileHeader.firstChild);
  }

  /* Untermenüs: der Eltern-Link klappt auf/zu statt zu navigieren.
     Das href bleibt stehen, damit der Link crawlbar und per Tastatur erreichbar ist. */
  var subLists = qsa('.mobile-menu-sub-link-list');
  /* Auf- und Zuklappen animiert assets/mobile-menu.css; die genaue Höhe als max-height sorgt dafür,
     dass die Liste gleichmäßig gleitet statt zu springen */
  function setSubOpen(list, open) {
    clearTimeout(list._mmTimer);
    if (open) {
      list.style.maxHeight = list.scrollHeight + 'px';
      /* Fallback, falls kein transitionend kommt (z. B. „Bewegung reduzieren“): Höhe trotzdem freigeben */
      list._mmTimer = setTimeout(function () { if (list.getAttribute('data-open') === 'true') list.style.maxHeight = 'none'; }, 600);
    } else {
      /* von der aktuellen Höhe aus zuklappen (nach dem Öffnen steht max-height auf none) */
      list.style.maxHeight = list.scrollHeight + 'px';
      void list.offsetHeight;
      list.style.maxHeight = '0px';
    }
    list.setAttribute('data-open', open ? 'true' : 'false');
    if (list.previousElementSibling) list.previousElementSibling.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  subLists.forEach(function (list) {
    var trigger = list.previousElementSibling;
    if (!trigger) return;
    /* fertig aufgeklappt: Höhe freigeben, damit nichts abgeschnitten wird (Schrift lädt nach, Handy gedreht) */
    list.addEventListener('transitionend', function (e) {
      if (e.target === list && e.propertyName === 'max-height' && list.getAttribute('data-open') === 'true') list.style.maxHeight = 'none';
    });
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = list.getAttribute('data-open') === 'true';
      /* immer nur ein Untermenü offen, damit das Menü auf einen Bildschirm passt */
      subLists.forEach(function (other) {
        if (other !== list && other.getAttribute('data-open') === 'true') setSubOpen(other, false);
      });
      setSubOpen(list, !isOpen);
      /* Social und Satz unten klappen weg, solange ein Untermenü offen ist */
      if (mobileContent) mobileContent.classList.toggle('mm-sub-offen', !isOpen);
      /* falls es doch nicht passt (kleines Handy): aufgeklapptes Untermenü ins Bild holen */
      if (!isOpen && mobileContent) setTimeout(function () {
        var over = list.getBoundingClientRect().bottom - mobileContent.getBoundingClientRect().bottom + 16;
        if (over > 0) mobileContent.scrollBy({ top: over, behavior: 'smooth' });
      }, 480);
    });
  });

  /* ---------------------------------------------------------------------
     2. Warenkorb-Drawer öffnen
     --------------------------------------------------------------------- */
  function openCartDrawer() {
    var drawer = qs('#cart-drawer');
    if (!drawer) return;
    var content = qs('.cart-drawer-content', drawer);
    var overlay = qs('#cart-drawer-overlay');
    drawer.style.visibility = 'visible';
    drawer.classList.add('is-open');
    if (overlay) { overlay.style.opacity = '1'; overlay.style.pointerEvents = 'auto'; }
    if (content) { content.classList.add('is-open'); content.style.transform = 'translateX(0)'; }
    document.body.classList.add('cart-drawer-open');
    document.body.style.overflow = 'hidden';
    /* Fokus in den Warenkorb setzen (Tastatur und Screenreader) */
    setTimeout(function () {
      var closeBtn = qs('#cart-drawer [data-mc-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }, 50);
  }

  qsa('.header-menu-cart-drawer').forEach(function (el) {
    el.addEventListener('click', openCartDrawer);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openCartDrawer(); }
    });
  });

  /* "In den Warenkorb" abfangen: per Ajax hinzufügen, Drawer neu laden und öffnen */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action="/cart/add"], form[action$="/cart/add"]');
    if (!form || !qs('#cart-drawer')) return;
    e.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var originalHTML = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.textContent = 'Wird hinzugefügt …'; }

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (res.ok) return res.json();
        /* Shopify liefert bei "ausverkauft" oder zu hoher Menge eine verständliche Beschreibung */
        return res.json().catch(function () { return {}; }).then(function (data) {
          var err = new Error('add');
          err.userMessage = data && data.description;
          throw err;
        });
      })
      .then(function () { return fetch('/?section_id=' + CART_SECTION_ID); })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = qs('.cart-drawer-content', temp);
        var current = qs('.cart-drawer-content');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        openCartDrawer();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (err) { alert((err && err.userMessage) || 'Fehler beim Hinzufügen. Bitte erneut versuchen.'); })
      .then(function () { if (button) { button.disabled = false; button.innerHTML = originalHTML; } });
  });

  /* ---------------------------------------------------------------------
     3. Footer-Spalten auf dem Smartphone auf-/zuklappen
     --------------------------------------------------------------------- */
  qsa('.footer-column-menu h2').forEach(function (heading) {
    heading.addEventListener('click', function () {
      if (window.innerWidth >= 768) return;
      var list = heading.nextElementSibling;
      if (!list) return;
      var indicator = heading.querySelector('span:last-child');
      var hidden = getComputedStyle(list).display === 'none';
      list.style.display = hidden ? 'block' : 'none';
      if (indicator) indicator.textContent = hidden ? '-' : '+';
    });
  });

  /* ---------------------------------------------------------------------
     4. Theme-Editor: Drawer-Section nach dem Speichern öffnen
     --------------------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId === CART_SECTION_ID) openCartDrawer();
  });
})();
